<template>
  <v-row justify="center" v-if="plan_inscripcion">
    <v-dialog v-model="dialog" scrollable width="500px">
      <v-card tile>
        <v-toolbar dark color="primary" dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> {{ plan_inscripcion.nombre }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table :headers="headers" :items="plan_inscripcion.cobros_programa" hide-default-footer disable-pagination> </v-data-table>
        <v-divider></v-divider>
        <v-card-subtitle v-if="persona && plan_inscripcion.aprobado" primary-title class="my-0 py-0">
          <p class="ma-0 pa-0">
            Plan de Programa aprobado por: <span class="font-weight-bold"> {{ persona.nombres }} {{ persona.pri_apellido }} {{ persona.seg_apellido }}</span>
            <br />
            Plan de Programa:
            <span :class="`font-weight-bold ${plan_inscripcion.estado ? 'info--text' : 'red--text'}`">
              {{ plan_inscripcion.estado ? 'Aprobado' : 'Deshabilitado' }}
            </span>
            <br />
            Plan de pagos:
            <span :class="`font-weight-bold ${plan_pagos_aprobado ? 'info--text' : 'red--text'}`">
              {{ plan_pagos_aprobado ? 'Aprobado' : 'No Aprobado' }}
            </span>
          </p>
        </v-card-subtitle>
        <v-card-subtitle v-else class="my-0 py-0">
          <p class="ma-0 pa-0">Estado de Plan: <span class="font-weight-bold"> No Aprobado </span></p>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top v-if="plan_pagos_aprobado">
            <template #activator="{ on, attrs }">
              <v-btn color="success" rounded v-bind="attrs" @click="openDialogKardex()" v-on="on">
                <v-icon class="mx-2"> mdi-eye</v-icon> Ver Kardex de Pagos
              </v-btn>
            </template>
            Generar Kardex
          </v-tooltip>

          <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cerrar <v-icon class="mx-2"> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <kardex-pagos ref="refKardex"></kardex-pagos>
  </v-row>
</template>

<script>
import gql from 'graphql-tag';
import KardexPagos from './KardexPagos';
export default {
  components: { KardexPagos },
  data() {
    return {
      dialog: false,
      plan_inscripcion: null,
      persona: null,
      plan_pagos: [],
      headers: [
        { text: 'Nombre', value: 'concepto_pago.nombre' },
        { text: 'Monto', value: 'monto' },
        { text: 'Cuotas', value: 'cuotas' },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(inscripcion) {
      //window.console.log('showThisView',inscripcion);
      this.dialog = true;
      this.inscripcion = inscripcion;
      this.plan_pagos_aprobado = inscripcion.estado_plan_cobro_programa;
      this.plan_pagos = inscripcion.plan_pagos;
      this.plan_inscripcion = inscripcion.plan_programa;
      this.plan_inscripcion.aprobado ? this.get_user_was_aprobe(inscripcion.aprobado_plan_cobro_programa_user_id) : null;
    },
    get_user_was_aprobe(id) {
      const sql = gql`query{ getPersona(id:${id}){ id num_doc nombres pri_apellido seg_apellido }}`;
      this.$apollo.query({ query: sql }).then(({ data }) => (this.persona = data.getPersona));
    },
    openDialogKardex() {
      //window.console.log('openkardexxxx',this.inscripcion.programa);
      this.$refs.refKardex.showThisView(this.inscripcion.estudiante, this.inscripcion.plan_programa, this.inscripcion.plan_pagos, this.inscripcion.programa,this.inscripcion.id);
    },

    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.plan_inscripcion = null;
        this.persona = null;
        this.plan_pagos = [];
      });
    },
  },
};
</script>
